export type SupportRegion = "iraq" | "kurdistan";

export interface SupportPhoneEntry {
  id: string;
  display: string;
  tel: string;
  region: SupportRegion;
}

export const SUPPORT_EMAIL = "support@alhayat-so.iq";

export const SUPPORT_PHONES: SupportPhoneEntry[] = [
  {
    id: "iraq-1",
    display: "+964782 336 0920",
    tel: "+9647823360920",
    region: "iraq",
  },
  {
    id: "iraq-2",
    display: "+964781 305 0947",
    tel: "+9647813050947",
    region: "iraq",
  },
  {
    id: "kurdistan",
    display: "+964 789 341 5647",
    tel: "+9647893415647",
    region: "kurdistan",
  },
];

export function phonesForRegion(region: SupportRegion): SupportPhoneEntry[] {
  return SUPPORT_PHONES.filter((phone) => phone.region === region);
}
